import { render, staticRenderFns } from "./kg.vue?vue&type=template&id=5c769a15&scoped=true"
import script from "./kg.vue?vue&type=script&lang=js"
export * from "./kg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c769a15",
  null
  
)

export default component.exports